@if (pagelet()?.hasParam('Link')) { @if (isRouterLink(pagelet(), 'Link')) {
<a [routerLink]="routerLink(pagelet(), 'Link')" [attr.title]="pagelet().stringParam('LinkTitle')" class="teaser-link">
  <ng-container *ngTemplateOutlet="image" />
</a>
} @else {
<a [href]="pagelet().stringParam('Link')" [attr.title]="pagelet().stringParam('LinkTitle')" class="teaser-link">
  <ng-container *ngTemplateOutlet="image" />
</a>
} } @else {
<div [ngClass]="pagelet().stringParam('CSSClass')">
  <img
    loading="lazy"
    [src]="pagelet().stringParam('Image')"
    [alt]="pagelet().stringParam('AlternateText') || ('image.alt_text.default' | translate)"
  />
</div>
}

<ng-template #image>
  <div [ngClass]="pagelet().stringParam('CSSClass')">
    <img
      loading="lazy"
      [src]="pagelet().stringParam('Image')"
      [alt]="pagelet().stringParam('AlternateText') || ('image.alt_text.default' | translate)"
    />
  </div>
</ng-template>
